/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-05-10 15:49:33
 * @LastEditors: Please set LastEditors
 */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { envManage } from '../store/actions';
import { ColonyDataType, UpdateHostListType } from './types';
import { getHostDetailApi } from 'root/services/disk';
import Alone from './Alone';
import Colony from './Colony';

let loopTimer: any = null;

const HostMonitor = () => {
  const { runtimeEnvId, cluster, refersh } = JSON.parse(sessionStorage.getItem('envStatus') || '');
  const [dataSource, setDataSource] = useState<ColonyDataType | null>(null);
  const [filterValue, setFilterValue] = useState<UpdateHostListType>({ ids: [] });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!runtimeEnvId) return;
    getList(filterValue);

    return () => {
      clearTimeout(loopTimer);
    };
  }, [refersh, filterValue]);

  // 论询
  const loopGetData = (params: any) => {
    loopTimer = setTimeout(() => {
      getList(params);
    }, 1000 * 15);
  };

  const getList = (params: UpdateHostListType) => {
    if (loopTimer) {
      clearTimeout(loopTimer);
    }

    getHostDetailApi(params).then((res) => {
      const {
        data: {
          serverNodeBriefs = [],
          labelStatusGroupUsed = [],
          labelStatusGroupNotUsed = [],
          productInstalled = false,
        } = {},
        data,
      } = res;

      if (cluster) {
        const obj: any = {
          productInstalled,
          serverNodeBriefs,
          labelStatus: [],
        };
        // 集群环境保存数据
        if (productInstalled) {
          // 安装supos，显示未使用块，需要将所有的未使用合并为一个模块，放到末尾
          obj.labelStatus = [...labelStatusGroupUsed];
          const tempArr: any = [];
          labelStatusGroupNotUsed.forEach((item: any) => {
            tempArr.push(...item.arrStatus);
          });
          obj.labelStatus.push({
            label: '未使用',
            arrStatus: tempArr,
          });
        } else {
          // 未安装Supos， 不显示未使用块，需要将未使用与已使用的数据合并。
          const resData = labelStatusGroupUsed.concat(labelStatusGroupNotUsed);
          const dataInfo: any = {};
          resData.forEach((item: any) => {
            const { label } = item;
            if (!dataInfo[label]) {
              dataInfo[label] = {
                label,
                arrStatus: [],
              };
            }
            dataInfo[label].arrStatus.push(...item.arrStatus);
          });
          obj.labelStatus = Object.values(dataInfo);
        }
        setDataSource(obj);
        loopGetData(params);
      } else {
        // 单机环境保存主机id
        dispatch(
          envManage.changeEnvStatus({
            singleNodeId: serverNodeBriefs[0]?.id, // 主机节点id
          }),
        );
        setDataSource(data);
      }
    });
  };

  return cluster ? <Colony updateHostList={setFilterValue} data={(dataSource as ColonyDataType) || {}} /> : <Alone />;
};

export default HostMonitor;
